import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import {
  clientErrorTracker,
  getPagePath,
  trans
} from '@spotahome/soyuz/client';
import getGqlClient from '@spotahome/marketplace-common/src/graphql/client';
import { getNearbyCitiesQuery } from '@spotahome/marketplace-common/src/graphql/queries/nearbyCities';

import './NearbyCitiesStrip.scss';

const fetchNearby = async bbox => {
  try {
    const { data } = await getNearbyCitiesQuery(getGqlClient())({ bbox });
    return data?.nearbyCities ?? [];
  } catch (error) {
    clientErrorTracker.warning({
      error,
      source: 'NearbyCitiesStrip-Fetch'
    });
    return [];
  }
};

const cityUrl = cityId =>
  getPagePath('marketplace.free-search', {
    params: { locationString: cityId }
  });

const NearbyCitiesStrip = ({ bbox }) => {
  const [cities, setCities] = useState([]);

  useEffect(() => {
    if (!bbox) return undefined;
    let cancelled = false;
    fetchNearby(bbox).then(result => {
      if (!cancelled) setCities(result);
    });
    return () => {
      cancelled = true;
    };
  }, [bbox?.neLat, bbox?.neLng, bbox?.swLat, bbox?.swLng]);

  if (!cities.length) return null;

  return (
    <div className="nearby-cities-strip" data-test="nearby-cities-strip">
      <div className="nearby-cities-strip__title">
        {trans('search.nearby-cities.title')}
      </div>
      <div className="nearby-cities-strip__cards">
        {cities.map(({ cityId, distanceKm }) => (
          <a
            key={cityId}
            href={cityUrl(cityId)}
            className="nearby-cities-strip__card"
            data-test={`nearby-cities-card-${cityId}`}
          >
            <span className="nearby-cities-strip__city">
              {cityId.replace(/_/g, ' ')}
            </span>
            <span className="nearby-cities-strip__distance">
              {Math.round(distanceKm)} km
            </span>
          </a>
        ))}
      </div>
    </div>
  );
};

NearbyCitiesStrip.propTypes = {
  bbox: PropTypes.shape({
    neLat: PropTypes.number.isRequired,
    neLng: PropTypes.number.isRequired,
    swLat: PropTypes.number.isRequired,
    swLng: PropTypes.number.isRequired
  })
};

export default NearbyCitiesStrip;
